import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import { Tag } from 'rsuite';
import DeleteConfirmationModal from '../../DeleteConfirmationModal';

export default class InventoryItemSkus extends Component {
  static propTypes = {
    skus: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasFullAccess: PropTypes.bool.isRequired,
    onDeleteSku: PropTypes.func.isRequired,
    isDeletingItem: PropTypes.bool.isRequired,
    isDeletedItem: PropTypes.bool.isRequired,
    isDeletingPackage: PropTypes.bool.isRequired,
    isDeletedPackage: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showConfirmDeleteSku: false,
      skuToDelete: null
    };
  }

  componentDidUpdate({
    isDeletedItem: prevIsDeletedItem,
    isDeletedPackage: prevIsDeletedPackage
  }) {
    const { isDeletedItem, isDeletedPackage } = this.props;
    if (
      (!prevIsDeletedItem && isDeletedItem) ||
      (!prevIsDeletedPackage && isDeletedPackage)
    ) {
      this.onItemDeleted();
    }
  }

  onItemDeleted = () => {
    this.handleHideDeleteSkuModal();
  };

  handleRemoveSku = skuToDelete => {
    this.setState({ skuToDelete });
    this.handleOpenDeleteSkuModal();
  };

  handleOpenDeleteSkuModal = () => {
    this.setState({ showConfirmDeleteSku: true });
  };

  handleHideDeleteSkuModal = () => {
    this.setState({ showConfirmDeleteSku: false });
  };

  handlConfirmDeleteSku = () => {
    const { onDeleteSku } = this.props;
    const { skuToDelete } = this.state;
    onDeleteSku(skuToDelete);
  };

  render() {
    const { skuToDelete, showConfirmDeleteSku } = this.state;
    const {
      skus,
      hasFullAccess,
      isDeletingItem,
      isDeletingPackage
    } = this.props;
    const isDeleting = isDeletingItem || isDeletingPackage;
    return (
      <Fragment>
        {map(
          itemSku => (
            <Tag
              key={itemSku.id}
              closable={hasFullAccess}
              onClose={() => {
                this.handleRemoveSku(itemSku);
              }}
            >
              {itemSku.sku}
            </Tag>
          ),
          skus
        )}
        {skuToDelete && (
          <DeleteConfirmationModal
            message={`Are you sure you want to delete sku ${skuToDelete.sku}`}
            show={showConfirmDeleteSku}
            onHide={this.handleHideDeleteSkuModal}
            onConfirm={this.handlConfirmDeleteSku}
            isDeleting={isDeleting}
          />
        )}
      </Fragment>
    );
  }
}
